/**
 * Normalizes payloads from Supabase RPC `match_user_to_group`.
 * Used by EventsList, parity hook, and EventDetail so rejoin/matched/queue handling stays aligned.
 */

export function classifyMatchUserToGroupPayload(data) {
  if (!data || typeof data.outcome !== 'string') return { kind: 'invalid' };
  switch (data.outcome) {
    case 'matched':
    case 'already_member':
      return { kind: 'matched', groupId: data.group_id };
    case 'rejoin_available':
      return {
        kind: 'rejoin_available',
        candidates: Array.isArray(data.candidates) ? data.candidates : [],
      };
    case 'queued':
      return { kind: 'queued' };
    case 'closed':
      return { kind: 'closed' };
    case 'error':
      return { kind: 'rpc_error', message: data.message };
    default:
      return { kind: 'unknown', outcome: data.outcome };
  }
}
